// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCiIoxgN1f-zss74rl106M10JTi-935iPc",
  authDomain: "steamanddrive-d6137.firebaseapp.com",
  projectId: "steamanddrive-d6137",
  storageBucket: "steamanddrive-d6137.firebasestorage.app",
  messagingSenderId: "417548562494",
  appId: "1:417548562494:web:c4521d3ffe6aaedb26a16f",
  measurementId: "G-M46GNWKBED",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

export { auth, analytics };
export default app;
